import React, { useEffect, useState } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { parse, isValid } from 'date-fns';
import { withFormik } from 'formik';
import * as yup from 'yup';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { FormControl, FormControlLabel, FormGroup, Checkbox } from '@material-ui/core';


import Input from '../../../../components/Input/Input';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Typography
} from '@material-ui/core';


const styles = theme => ({
  button: {
    display: 'inherit',
    margin: `${theme.spacing(2)}px auto`,
    minWidth: '300px',
    minHeight: '50px',
  },
  hover: {
    borderRadius: '1em',
    margin: ' 14px 4px',
    textAlign: 'center',
    width: '100%',
    color: '#537ccd',
    textTransform: 'none',
    marginRight: '2px',
    fontSize: '15px',
    fontWeight: 400,
    '&:hover': {
      color: '#6880c3',
      backgroundColor: '#f2b002',
    }
  }
});

const Form = (props) => {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    setFieldValue,
    returning,
    classes
  } = props;

  const formFields = [];

  let formFieldsAux = [
    ...formFields,
  ];

  let signal = '+';
  if (props.values.hasBankOfHours) {
    const conditionalFields = [
      {
        elementType: 'maskedInput',
        config: {
          type: 'text',
          name: 'initialValue',
          label: 'Valor inicial',
          required: true,
          mask: (value) => {
            if (value === '-' || value.indexOf('-') === 0) {
              signal = '-';
            }

            if (value === ' :  ' || value === '- :  ') {
              signal = '+';
            }

            if ((signal === '+') && value.replace(/\s/g, '').length <= 5) {
              return [/\d/, /\d/, ':', /\d/, /\d/];
            }

            if ((signal === '+') && value.replace(/\s/g, '').length > 5) {
              return [/\d/, /\d/, /\d/, ':', /\d/, /\d/];
            }

            if ((signal === '-') && value.replace(/\s/g, '').replace(/-/g, '').length <= 5) {
              return [signal, /\d/, /\d/, ':', /\d/, /\d/];
            }

            if ((signal === '-') && value.replace(/\s/g, '').replace(/-/g, '').length > 5) {
              return [signal, /\d/, /\d/, /\d/, ':', /\d/, /\d/];
            }
          },
        },
        helperText: ' ',
      },
      {
        elementType: 'datePicker',
        config: {
          name: 'dtFrom',
          label: 'Início do Banco de horas',
          required: true,
          isFormik: true,
        },
        helperText: 'Data Inválida',
      },
      {
        elementType: 'datePicker',
        config: {
          name: 'dtTo',
          label: 'Término do Banco de horas',
          required: false,
          isFormik: true,
        },
        helperText: 'Data Inválida',
      },
    ];

    formFieldsAux = [...formFields, ...conditionalFields];
  } else {
    formFieldsAux = [
      ...formFields,
    ];
  }

  if (returning) {
    props.setReturning(false);
    props.formValues(values);
  }

  if (props.formValues) {
    props.formValues(values);
  }

  if (props.submit) {
    if (props.submit.toggle) {
      props.setSubmit({ event: null, toggle: false });
      props.handleSubmit(props.submit.event);
    }
  }
  if (props.setBankOfHoursIsValid) {
    props.setBankOfHoursIsValid(Object.entries(props.errors).length === 0 && props.errors.constructor === Object);
  }
  const [bloquedYear, setBloquedYear] = useState(false)
  const [closeBloquedYear, setCloseBloquedYear] = useState(true)

  var dtYear = values.dtFrom ? new Date(values.dtFrom.getFullYear() + 1, values.dtFrom.getMonth(), values.dtFrom.getDate()) : null;

  if (values?.dtTo > dtYear && bloquedYear == false) {
    setBloquedYear(true)
  }

  if (values?.dtTo > dtYear && closeBloquedYear == false) {
    setBloquedYear(false);
    values.dtTo = ''
    setCloseBloquedYear(true)
  }

  function closeModal() {
    setCloseBloquedYear(false)
    dtYear = null
  }
  const [premium, setpremium] = useState(JSON.parse(localStorage.getItem('privileges')).isExportAfd)
  const [premiumItem, setpremiumItem] = useState(false)

  function handleChangeHover(status) {
    if (!premium) {
      setpremiumItem(status)
    }
  };

  return (
    <form onSubmit={(e) => { e.preventDefault(); }}>
      <Grid item container spacing={2}>
        <Grid item xs={12} sm={6} key="fieldset" style={{ display: 'flex' }}>
          {!premiumItem ?
            <FormControl
              component="fieldset" style={{ margin: 'auto', marginLeft: '0' }}
              onMouseEnter={() => handleChangeHover(true)}
              onMouseLeave={() => handleChangeHover(false)}
            >
              <FormGroup row>
                <FormControlLabel
                  key="hasBankOfHours"
                  name="hasBankOfHours"
                  control={<Checkbox color="primary" checked={values.hasBankOfHours} onChange={handleChange} value={values.hasBankOfHours} />}
                  label="Ativar Regime de Banco de horas"
                />
              </FormGroup>
            </FormControl> :
            <div
              onMouseEnter={() => handleChangeHover(true)}
              onMouseLeave={() => handleChangeHover(false)}
            >
              <Button
                className={classes.hover}
                component={Link}
                to='/assinatura'
              >
                <Typography>
                  Seja Premium para ativar o Regime de Banco de Horas
                </Typography>
              </Button>
            </div>
          }
        </Grid>
        {formFieldsAux.map((field, index) => {
          const items = [];
          items.push((
            <Grid item xs={12} sm={6} key={field.config.name}>
              <Input
                {...field.config}
                elementType={field.elementType}
                value={values[field.config.name]}
                onChange={field.elementType === 'datePicker' ? setFieldValue : handleChange}
                onBlur={handleBlur}
                minDate={field.config.name === 'dtTo' && values.dtFrom && values.dtFrom}
                fullWidth
                margin="normal"
                error={field.elementType === 'datePicker' ? touched[field.config.name] && !isValid(values[field.config.name]) : errors[field.config.name] && touched[field.config.name]}
                helperText={
                  field.elementType === 'datePicker' ? (
                    (touched[field.config.name] && !isValid(values[field.config.name])) && field.helperText
                  ) : (
                    touched[field.config.name] && errors[field.config.name]
                  )
                }
                InputProps={{
                  inputComponent: field.maskComponent,
                }}
              />
            </Grid>
          ));

          return items;
        })}
        {props?.values?.hasBankOfHours && (
          <Grid item xs={12} sm={6}>
            <FormControl component="fieldset" style={{ margin: 'auto', marginLeft: '0' }}>
              <FormGroup row>
                <FormControlLabel
                  key="cumulativeHoursLimit"
                  name="cumulativeHoursLimit"
                  label="Ativar limite de 2 horas por dia para banco"
                  control={
                    <Checkbox
                      color="primary"
                      // checked={values.cumulativeHoursLimit}
                      onChange={handleChange}
                      value={values.cumulativeHoursLimit}
                    />}
                />
              </FormGroup>
            </FormControl>
          </Grid>
        )}
      </Grid>
      {
        props.innerSubmit ? (
          <Grid item container justify="flex-end" spacing={1} >
            <Button
              onClick={props.close}
              style={{ marginRight: 10, marginTop: 10, marginBottom: 20 }}
            >
              FECHAR
            </Button>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              onClick={props.handleSubmit}
              style={{ marginTop: 10, marginBottom: 20 }}
              disabled={values?.dtTo > dtYear ? true : false}
            >
              SALVAR
            </Button>
          </Grid>
        ) : null
      }
      <Dialog
        open={bloquedYear}
        onClose={() => closeModal()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      // maxWidth='lg'
      >

        <DialogTitle id="alert-dialog-title">
        </DialogTitle>
        <DialogTitle id="alert-dialog-title">
          <Typography style={{ color: '#3978D3', fontWeight: 'bold', fontSize: '40px', textAlign: 'center' }} >Lamentamos :(</Typography>
          <DialogContent>
            <DialogContentText id="alert-dialog-description" style={{ textAlign: 'center' }}>
              <Typography style={{ textAlign: 'center', fontSize: '20px' }}>
                Mas o cadastro do banco de horas não pode exceder o período de um ano. Por favor, tente inserir um período menor.
              </Typography>
            </DialogContentText>
          </DialogContent>

        </DialogTitle>
        <Grid style={{ textAlign: 'center' }}>
          <Button
            variant='contained'
            style={{ transform: "translateX(200%)", transform: "translateY(-50%)" }}
            onClick={() => closeModal()}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;SAIR&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </Button>
        </Grid>
      </Dialog >
    </form >

  );
};

const initializeDateForm = item => (item ? parse(item, 'yyyy-MM-dd', new Date()) : null);
const initializeBoolean = item => item || false;

const initializeHours = (min) => {
  if (min && typeof min !== 'string') {
    let hours = min < 0 ? Math.floor((min * -1) / 60) : Math.floor(min / 60);
    let minutes = min % 60;

    if (min < 0) {
      hours *= -1;
    }

    if (hours > 0 && hours.toString().length <= 2) {
      hours = `0${hours}`;
    }


    if (hours < 0 && hours.toString().length <= 3) {
      hours = `-0${hours * -1}`;
    }


    if (minutes > 0 && minutes <= 9) {
      minutes = `0${minutes}`;
    }

    if (minutes <= 0 && -1 * minutes <= 9) {
      minutes = `-0${minutes * -1}`;
    }

    return `${hours}:${minutes}`;
  }

  if (min && typeof min === 'string') {
    return min;
  }

  return '00:00';
};

const BankOfHoursForm = withFormik({
  enableReinitialize: false,
  mapPropsToValues: props => ({
    hasBankOfHours: initializeBoolean(props.data.hasBankOfHours),
    initialValue: initializeHours(props.data.initialValue) || '00000',
    dtTo: initializeDateForm(props.data.dtTo),
    dtFrom: initializeDateForm(props.data.dtFrom),
    cumulativeHoursLimit: props.data.cumulativeHoursLimit ? props.data.cumulativeHoursLimit : false,
  }),
  validationSchema: props => yup.lazy((values) => {
    const rules = {};

    if (values.hasBankOfHours) {
      rules.initialValue = yup
        .string()
        .strict(false)
        .trim('O valor inicial deve obedecer HH:MM ou HHH:MM')
        .required()
        .nullable();

      rules.dtTo = yup.string().required('Este campo é obrigatório').nullable();
      rules.dtFrom = yup.string().required('Este campo é obrigatório').nullable();
    }

    return yup.object().shape(rules);
  }),
  handleSubmit: (values, { props }) => {
    if (props.innerSubmit) {
      props.updateEmployee(values);
      props.close();
    } else {
      props.formValues(values);
      props.setFormsStatus({ ...props.formsStatus, bankOfHours: true });
    }
  },
})(Form);

export default withStyles(styles)(withRouter(BankOfHoursForm));
